
import { Component, Vue, Emit } from "vue-property-decorator";
import {
    OrderRecordDetail,
    OrderRecordUnsubscribeInput,
} from "@/api/service-proxies";
import moment from "moment";
import { orderRecordService } from "@/api/payments/order-record";

@Component
export default class UnsubscribeDialog extends Vue {
    private dialogVisible: boolean = false;
    isUnsubscribeRecord: boolean = false;
    private recordState = 0;
    imgs: [];
    orderId: string;
    tenantId:number
    isSkipHolidays: boolean = false;
    isExporting: boolean = false;
    testList=[]
    orderRecordDetail = new OrderRecordDetail();

    public open(id, state,tenantId) {
        this.orderId = id;
        this.recordState = state;
        this.tenantId = tenantId;
        this.getOrderRecordInfo(id);
        this.dialogVisible = true;
    }

    getOrderRecordInfo(id) {
        orderRecordService
            .getOrderRecordDetail(id)
            .then((result) => {
                console.log(result);
                this.orderRecordDetail = result;
                this.isUnsubscribeRecord = result.isUnsubscribeRecord;
                this.testList= JSON.parse(this.orderRecordDetail.imgUrls)
            })
            .finally(() => {
                //this.dialogVisible = false
            });
    }

  //退订 和取消退订
  submit(isAgree){
    this.$confirm(isAgree?"确定要退订?":"确定要取消退订?")
      .then(async () => {
        var input= new OrderRecordUnsubscribeInput({
          id : this.orderRecordDetail.id,
          orderRecordState : this.recordState,
          isAgree : isAgree,
          tenantId :this.tenantId
        })
        orderRecordService.updateOrderRecordUnsubscribe(input)
        .then(()=>{
            this.$message.success(isAgree?"退订成功":"取消退订成功?")
            this.onSuccess()
        })
        .catch(()=>{
            this.$message.error(isAgree?"退订失败":"取消退订失败?")
            this.onSuccess()
        })
        .finally(()=>{
          this.dialogVisible=false
        })
      })
      .catch(() => {});
  }

    @Emit("success")
    private onSuccess() {}

    close() {
        this.dialogVisible = false;
    }
}
